import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * 160 ms opacity fade on mobile route mounts.
 * Opacity only — a parent transform would break position:fixed overlays.
 */
export function PortalPage ({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()

  useEffect(() => {
    const scroller = document.querySelector('.portal-content, .staff-app-content')
    if (scroller instanceof HTMLElement) scroller.scrollTop = 0
  }, [pathname])

  return (
    <div key={pathname} className='portal-page'>
      {children}
    </div>
  )
}
